import Vue from 'vue'
import Vuex from 'vuex'
import { dbPull, db_names, support_db, updateViews, startSyncDb, connectRemoteDb, getQuery } from './utils/dbUtility.js'
import {useRemoteConnection} from './utils/rolesManagement.js';
// import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        localDb_pull: null,
        localDb_push: null,
        localdb_system_pull: null,
        loggedin: false,
        token: null,
        user: null,
        c_operation: {
            op: null,
            c_client: null,
            c_location: null
        },
        users: null,
        config: null,
        search: {},
        snackbar: {
            show: false,
            text: "",
            color: "success"
        },
        offline: false,
        software_version: null,
        db_doc_selectors: {},
        loading_db: {},
        loading_dbs: true,
        start_sync: false,
        logoutError: false,
        fatalError: false,
        $pouch: null,
        $remote_pouch: null,
        $local_pouch: null,
        sync_since: {}
    },
    mutations: {
        login(state, data) {
            state.token = data.token;
            state.loggedin = true;
            console.log("login STATE", state)
        },

        logout(state) {
            console.log('logout')
            state.loggedin = false;
            //window.location.reload()
        },
        closeSnackbar: function(state) {
            state.snackbar.show = false
        },
        showSnackbar: function(state, data) {
            state.snackbar.text = data.text
            state.snackbar.color = data.color ? data.color : 'info'
            state.snackbar.show = true
        },
        startSync: function(state, data) {
            state.start_sync = data.start
        },
        loadingDbs: function(state, data) {
            state.loading_dbs = data.loading
        },
        loadingDb: function(state, data) {
            state.loading_db[data.db] = data.loading_db
        },
        updateUsers: async function(state) { //, data) {
            state.users = _.keyBy(JSON.parse(localStorage.getItem('mastercal_users')), function(u) {
                return u._id
            })
        },
        updateUser: function(state) {
            state.user = JSON.parse(localStorage.getItem('user'))
        },
        setPouches(state, data) {
          console.log('COMMIT SET POUCHES', data)
          state.$local_pouch = data.local_pouch;
          state.$remote_pouch = data.remote_pouch;
        },
        setPouchDb(state, data) {
            let selected_db = state.$local_pouch;
            if(useRemoteConnection(data.user.roles)) {
              selected_db = state.$remote_pouch;
            }
            
            state.$pouch = selected_db;
        },
        dbsRefs(state, data) {
            state.localDb_pull = data.db_pull
            state.localDb_push = data.db_push
            state.localdb_system_pull = data.system_db

        },
        startLoadingDb(state) {
            state.loading_db = Object.assign({}, ...db_names.map(db => ({
                [db]: true
            })));
            this.commit('loadingDbs', { loading: true })
        },

        async finishLoadingDb(state, data) {
            let tmp_loading = false 
            if (data.remote) {
              tmp_loading = false
            } else {
              state.loading_db[data.db] = false
              state.sync_since[data.db] = data.since
              tmp_loading = _.reduce(state.loading_db, function(result, key) {
                  return result || key;
              }, false);
            }
            console.log('tmp_loading', tmp_loading, data.db)
            if (!tmp_loading) {
                
                await updateViews(data.pouch, !data.remote)
                
                let conf = await data.pouch.get('system', 'config:data')
                console.log("%%%%%%% finish loading dbs - conf", conf, Date.now())
                this.commit('setConfig', conf)
                    //createMastercalDesignDocs(data.pouch)
            }
            this.commit('loadingDbs', { loading: tmp_loading })
                //state.loading_dbs = tmp_loading
        },

        setCurrentSoftwareVersion: function(state, version) {
            state.software_version = version
        },

        verifyUpdateSw: function(state) {
            console.log("verifyUpdateSw - software version:", state.software_version, ", sw sentinel:", localStorage.mastercal_sentinel_version)
            if (localStorage.mastercal_sentinel_version != state.software_version) {
                // TO DO RELOAD SW
                // stop pull from server

                if (state.localdb_system_pull) {
                    state.localdb_system_pull.cancel()
                }
                for (let db of db_names) {
                    if (state.localDb_pull[db]) {
                        state.localDb_pull[db].cancel()
                    }
                    if (state.localDb_push[db]) {
                        state.localDb_push[db].cancel()
                    }
                }

                //trigger reload sw
                //document.dispatchEvent(new CustomEvent('SWUpdated', { detail: { type: 'sentinel' } }));
                navigator.serviceWorker.getRegistration().then(registration => {
                    localStorage.mastercal_sw_version = state.software_version
                    if (registration) {
                        console.log('registration.update')
                        registration.update()

                    } else {
                        console.log('****** swUpdate with sentinel')
                        document.dispatchEvent(new CustomEvent('SWUpdated', { detail: { type: 'sentinel' } }));
                    }
                })
            }
        },
        setSelector: function(state, data) {
            if (!state.db_doc_selectors[data.db]) {
                state.db_doc_selectors[data.db] = {}
            }
            
            for (let doc_type of Object.keys(data.versions)) {
                state.db_doc_selectors[data.db][doc_type] = data.versions[doc_type].current_version
            }
            console.log(data.db, "- db_doc_selectors: ", state.db_doc_selectors)
        },
        setConfig: function(state, config) {
            console.log('config updated')
            state.config = config
        },
        setSearchParam: function(state, data) {
            if (data.resetAll) {
                state.search = {}
            } else {
                state.search[data.path] = {filter: data.filter, page: data.page, sort_fields: data.sort_fields}
            }
        },
        offline(state, data) {
            console.log("offline", data)
            state.offline = true;
        },
        online(state, data) {
            console.log("online", data)
                //this.commit('initPouch', data)
            state.offline = false;
        },
        logoutError: function(state, data) {
            state.logoutError = data.logout
        },
        fatalError: function(state) {
            state.fatalError = true
        }
    },
    actions: {
        async setUsers(context, data) {
            let axios = data.axios
            if (!context.state.offline) {
                let res = await axios.get("/mastercal/users/", { params: { include_dismissed: true }}).catch(error => {
                    console.log("error status", error);
                    //this.errorMessage = "errore di connessione - riprovare. Se il problema persiste contattare l'amministratore"
                    res = null
                });
                if (res) {
                    localStorage.setItem('mastercal_users', JSON.stringify(res.data))
                }
            }
            return Promise.resolve(context.commit("updateUsers"));
        },

        // async setUser(context, data) {
        //     let axios = data.axios
        //     if (!context.state.offline) {
        //         let res = await axios.get("/mastercal/users/" + data.uid).catch(error => {
        //             console.log("error status", error);
        //             //this.errorMessage = "errore di connessione - riprovare. Se il problema persiste contattare l'amministratore"
        //             res = null
        //         });
        //         if (res) {
        //             localStorage.setItem('user', JSON.stringify(res.data))
        //         }
        //     }
        //     return Promise.resolve(context.commit("updateUser"));
        // },
        async setUser(context, data) {
            console.log("setUser USER", data.user)
            localStorage.setItem('user', JSON.stringify(data.user))
            context.commit('setPouchDb', data); 
            return Promise.resolve(context.commit("updateUser"));
        },
        setPouches(context, data) {
          console.log('DISPATCH SET POUCHES')
          context.commit('setPouches', data);
        },
        startSyncDbs: async function(context, data) {
            console.log("%%%%%%% START SYNC DBS", Date.now())
            context.commit("startSync", { start: true });
            let pouch = data.pouch
            let that = this;
            if (useRemoteConnection(data.user.roles)) {
                console.log("%%%%%%% START SYNC DBS SKIPPED - use remote connection - connecting", Date.now())
                let remoteDb = {};
                for (let db of ['system', ...db_names]) {
                  remoteDb[db] = await connectRemoteDb(pouch, db)
                }
                context.commit('dbsRefs', { system_db: localdb_system_pull, db_pull: null, db_push: null, remote_db: remoteDb })
                let conf = await data.pouch.get('system', 'config:data')
                this.commit('setConfig', conf)
            
                context.commit("startSync", { start: false });
            
                return true;
            }
            if (context.state.localdb_system_pull != null) {
                console.log("context.state.localdb_system_pull", context.state.localdb_system_pull, context.state.localdb_system_pull._changes, context.state.localdb_system_pull._changes.rawListeners())
                    //context.state.localdb_system_pull._changes.removeAllListeners()
                context.state.localdb_system_pull.cancel()
                    //await pouch.close('system')
                console.log("After cancel context.state.localdb_system_pull", context.state.localdb_system_pull)
            }

            for (let db of db_names) {
                if (context.state.localDb_pull && context.state.localDb_pull[db] != null) {
                    //context.state.localDb_pull[db]._changes.removeAllListeners()
                    await context.state.localDb_pull[db].cancel()
                }
                if (context.state.localDb_push && context.state.localDb_push[db] != null) {
                    //context.state.localDb_push[db]._changes.removeAllListeners()
                    await context.state.localDb_push[db].cancel()
                }
                //await pouch.close(db)
            }

            let localDb_pull = {};
            let localDb_push = {};
            let systemDocs = await pouch.allDocs('system', { include_docs: true }).catch(error => {
                //    Promise.resolve(context.commit("initPouch", data))
                //    return
                return false
            });
            console.log("system docs", systemDocs)
            if (!systemDocs || !systemDocs.rows || systemDocs.rows.length == 0) {
                //    Promise.resolve(context.dispatch("initPouch", data))
                //    return
                return false
            }
            for (let doc of systemDocs.rows) {
                let doc_t_n = doc.id.split(':', 2)
                if (doc_t_n[1] == 'software') {
                    // software sentinel is stored in localStorage
                    // software version (from App.vue) is stored in vuex state
                    localStorage.mastercal_sentinel_version = doc.doc.doc_types.software.version
                        // that.commit('verifyUpdateSw')
                        //return

                } else if (doc_t_n[0] == 'sentinel' && doc_t_n[1] != 'software') {
                    that.commit("setSelector", { db: doc_t_n[1], versions: doc.doc.doc_types })
                } else if (doc.id == 'config:data') {
                    this.commit('setConfig', doc.doc)
                }
            }
            let localdb_system_pull = dbPull(pouch, 'system', {
                    live: true,
                    retry: true,
                    include_docs: true,
                    back_off_function: function(delay) {
                        console.log('BACKOFF DELAY SYSTEM', delay)
                        if (delay === 0) {
                            return 1000;
                        }
                        if (delay >= 30000) {
                            return delay
                        }
                        return delay * 3;
                    }
                },
                Function(), //complete_func 
                function(changes) { //change_func
                    for (let doc of changes.docs) {
                        if (doc._id == "sentinel:software") {
                            let ssentinel = doc
                            localStorage.mastercal_sentinel_version = ssentinel.doc_types.software.version
                            that.commit('verifyUpdateSw')
                        } else if (doc._id == "config:data") {
                            that.commit('setConfig', doc)
                        }
                    }
                },
                function(error) { // error_func
                    console.log("ERROR startSyncDbs triggered", error)
                        // localStorage.removeItem("__jwt")
                        // localStorage.removeItem("user")
                        // localStorage.removeItem("mastercal_users")
                        // that.commit("logout")
                        // that.commit("logoutError", { logout: true })
                    that.commit('fatalError')
                },
                function(info) { // active_func
                    console.log("ACTIVE startSyncDbs triggered", info)
                },
                function(paused) { // paused_func
                    console.log("PAUSED triggered", paused)
                });

            // console.log("--->", user, pwd, COUCH_ADDR);
            for (let db of db_names) {
                if (db == 'operations') {
                    localDb_pull[db], localDb_push[db] = startSyncDb(pouch, context, db, function(changes) { //change_func
                        let ids = Set()
                        for (let doc of changes.docs) {
                            ids.add(doc.client_id)
                            ids.add(doc.partner_id)
                            ids.add(doc.location_id)
                        }
                        var valid_ids = _.map([...ids], function(value) {return({'_id': value})})
                        console.log('support db add', valid_ids)
                        pouch.bulkDocs(support_db, valid_ids)
                    })    
                } else {
                    localDb_pull[db], localDb_push[db] = startSyncDb(pouch, context, db)
                }
            }
            context.commit('dbsRefs', { system_db: localdb_system_pull, db_pull: localDb_pull, db_push: localDb_push, })
                //context.commit("loadingDbs", { loading: false })
            context.commit("startSync", { start: false });
            // that.commit('updateUsers', data)
            return true
        },
        deleteDbs: async function(context, data) {
            if (useRemoteConnection(data.user.roles)) {
              return
            }
            let pouch = data.pouch
            await pouch.disconnect(support_db)
            await pouch.destroy(support_db)
            await pouch.disconnect('system')
            await pouch.destroy('system')

            for (let db of db_names) {
                if (context.state.localDb_pull && context.state.localDb_pull[db] && context.state.localDb_pull[db].state != "cancelled") {
                    await context.state.localDb_pull[db].cancel()
                }
                if (context.state.localDb_push && context.state.localDb_push[db] && context.state.localDb_push[db].state != "cancelled") {
                    await context.state.localDb_push[db].cancel()
                }
                //await pouch.close(db)
                console.log("pouch destroy", db)
                await pouch.disconnect(db)
                await pouch.viewCleanup(db)
                await pouch.destroy(db)
            }
        
        },
        startCopyDbs: async function(context, data) {
            console.log("%%%%%%% START COPY DBS", context.state, data, Date.now())
            let pouch = data.pouch
            context.commit('startLoadingDb')
            context.commit("logoutError", { logout: false })
            if (useRemoteConnection(data.user.roles)) {
              console.log("%%%%%%% REMOTE DBS - Not copying", Date.now())
              //context.commit('loadingDbs', { loading: false })
              this.commit('finishLoadingDb', { pouch: pouch, db: null, remote: true })
              return;
            }
            await this.dispatch('deleteDbs', data)
            /*for (let db of db_names) {
                if (context.state.localDb_pull && context.state.localDb_pull[db] && context.state.localDb_pull[db].state != "cancelled") {
                    await context.state.localDb_pull[db].cancel()
                }
                if (context.state.localDb_push && context.state.localDb_push[db] && context.state.localDb_push[db].state != "cancelled") {
                    await context.state.localDb_push[db].cancel()
                }
                //await pouch.close(db)
                console.log("pouch destroy", db)
                await pouch.viewCleanup(db)
                await pouch.destroy(db)
            }*/

            let that = this;
            dbPull(pouch, 'system', { live: false }, async function() {
                console.log("system db loaded")
                let systemDocs = []
                try {
                    systemDocs = await pouch.allDocs('system', { include_docs: true })
                } catch (error) {
                    that.commit('fatalError')
                }
                if (systemDocs.rows.length == 0) {
                    that.commit('fatalError')
                }
                for (let doc of systemDocs.rows) {
                    let doc_t_n = doc.id.split(':', 2)
                    if (doc_t_n[1] == 'software') {
                        console.log("software version: ", doc.doc.doc_types.software.version)
                        console.log(navigator.serviceWorker)
                            // software sentinel is stored in localStorage
                            // software version (from App.vue) is stored in vuex state
                        localStorage.mastercal_sentinel_version = doc.doc.doc_types.software.version
                        that.commit('verifyUpdateSw')
                    } else if (doc_t_n[0] == 'sentinel' && doc_t_n[1] != 'software') {
                        that.commit("setSelector", { db: doc_t_n[1], versions: doc.doc.doc_types })
                    }
                }
                

                if (context.state.user.roles.includes('admin') || context.state.user.roles.includes('reviewer')  || context.state.user.roles.includes('supervisor')) {
                    for (let db of db_names) {
                        let db_selector = context.state.db_doc_selectors[db]
                        console.log("startCopyDbs ADMIN- SET SELECTOR1", context.state.user.org_id, Date.now())
                        var query = getQuery(db, db_selector, true)
                        let options = {
                                live: false,
                                retry: true,
                                selector: query,
                                // filter: db + '/current_version',
                                // query_params: db_selector,
                                style: "main_only",
                                return_docs: false,
                                back_off_function: function(delay) {
                                    console.log('BACKOFF DELAY', db, delay)
                                    if (delay === 0) {
                                        return 1000;
                                    }
                                    if (delay >= 216000) {
                                        return delay
                                    }
                                    return delay * 3;
                                }
                            }
                        dbPull(pouch, db, options, async function(info) {
                            console.log('FINISH LOADING', db, info)
                            that.commit('finishLoadingDb', { pouch: pouch, db: db, remote: false, since: info.last_seq })
                        })
                    }
                } else {
                    let db_selector = context.state.db_doc_selectors['operations']
                    db_selector['user'] = context.state.user._id;
                    db_selector['org'] = context.state.user.org_id
                    var op_query = getQuery('operations', db_selector, true)
                    // console.log('operation query', JSON.stringify(op_query))
                    dbPull(pouch, 'operations', { live: false, selector: op_query }, async function(info_op) {

                        let operationsDocs = [];
                        let client_ids = new Set();
                        let location_ids = new Set();
                        let operation_ids = new Set();
                        let instrument_ids = new Set();
                        try {
                            operationsDocs = await pouch.allDocs('operations', { include_docs: true });
                        } catch (error) {
                            console.log('ERRRROOOR', error)
                            that.commit('fatalError')
                        }
                        for (let op of operationsDocs.rows) {
                            if (op.doc._id.startsWith('_design/')) {
                                continue
                            }
                            console.log('operation', op.doc._id, op.doc.client_id, op.doc.order_nr)
                            client_ids.add(op.doc.client_id)
                            client_ids.add(op.doc.partner_id)
                            location_ids.add(op.doc.location_id)
                            operation_ids.add(op.doc._id)
                            op.doc.instrument_ids.forEach(item => instrument_ids.add(item))
                        }
                        console.log('FINISH LOADING', 'oprations', info_op)

                        var valid_ids = _.map([...client_ids, ...location_ids], function(value) {return({'_id': value})})
                        // console.log('support db add', client_ids)
                        await pouch.bulkDocs(support_db, valid_ids)
                        that.commit('finishLoadingDb', { pouch: pouch, db: 'operations', remote: false, since: info_op.last_seq })
                        let other_selector = {
                            user: context.state.user._id,
                            clients: [...client_ids],
                            locations: [...location_ids],
                            operations: [...operation_ids],
                            instruments_ids: [...instrument_ids]
                        }
                        for (let db of ['masters', 'reports', 'registry']) {
                            let idb_selector = {...db_selector, ...other_selector}
                            console.log("startCopyDbs", db, context.state.user.org_id, Date.now())
                            var i_query = getQuery(db, idb_selector, true)
                            // console.log('QURY COPY', db, JSON.stringify(i_query))
                            let options = {
                                    live: false,
                                    retry: true,
                                    selector: i_query,
                                    // filter: db + '/current_version',
                                    // query_params: db_selector,
                                    style: "main_only",
                                    return_docs: false,
                                    back_off_function: function(delay) {
                                        console.log('BACKOFF DELAY', db, delay)
                                        if (delay === 0) {
                                            return 1000;
                                        }
                                        if (delay >= 216000) {
                                            return delay
                                        }
                                        return delay * 3;
                                    }
                                }
                            dbPull(pouch, db, options, async function(info) {
                                console.log('FINISH LOADING', db, info)
                                that.commit('finishLoadingDb', { pouch: pouch, db: db, remote: false, since: info.last_seq })
                            })
                        }
                    
                    }, Function(), function(error) {
                        // console.log("ERROR ON SYSTEM PULL", error)
                        // localStorage.removeItem("__jwt")
                        // localStorage.removeItem("user")
                        // localStorage.removeItem("mastercal_users")
                        // that.commit("logout")
                        // that.commit("logoutError", { logout: true })
                        that.commit('fatalError')
                    })
                }
                //that.commit('updateUsers', data)

            }, Function(), function(error) {
                // console.log("ERROR ON SYSTEM PULL", error)
                // localStorage.removeItem("__jwt")
                // localStorage.removeItem("user")
                // localStorage.removeItem("mastercal_users")
                // that.commit("logout")
                // that.commit("logoutError", { logout: true })
                that.commit('fatalError')
            })
        }
    }

})